import React, { useState, useEffect } from 'react';
import Navbar from '../../components/Navbar';
import '../../styles/StudentWall.css';
import './ClassActivities.css';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useNavigate, useParams } from 'react-router-dom';
import SchoolIcon from '@mui/icons-material/School';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ClassIcon from '@mui/icons-material/Class';
import GroupIcon from '@mui/icons-material/Group';
import { getClassActivitiesForStudent } from '../../services/activityService';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';

const menuGroups = [
  {
    title: '班級參與',
    items: [
      { icon: ClassIcon, text: '活動列表', active: true, onClick: () => window.location.href=`/student/class/${classId}/activities`},

    ],
  },
  {
    title: '我的參與',
    items: [
      { icon: SchoolIcon, text: '我的班級', active: false, onClick: () => window.location.href='/student/my-classes'},
      { icon: DashboardIcon, text: '學習儀表板', active: false },
    ],
  },
];

const ClassActivities = () => {
  const [activities, setActivities] = useState([]);
  const [allActivities, setAllActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userRole, setUserRole] = useState('student');
  const [currentRole, setCurrentRole] = useState('student');
  const navigate = useNavigate();
  const { classId } = useParams();

  useEffect(() => {
    fetchClassActivities();
  }, [classId]);

  const fetchClassActivities = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await getClassActivitiesForStudent(classId);
      
      if (response.success) {
        setActivities(response.data.studentActivities || []);
        setAllActivities(response.data.allClassActivities || []);
        setUserRole(response.data.userRole);
      } else {
        setError('取得活動資料失敗');
      }
    } catch (error) {
      console.error('Error fetching class activities:', error);
      setError(error.response?.data?.message || '取得活動資料失敗');
    } finally {
      setLoading(false);
    }
  };

  const handleRoleChange = (newRole) => {
    setCurrentRole(newRole);
    // 學生頁面不需要 host 角色切換
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('zh-TW');
  };

  const renderEmptyState = () => (
    <div style={{
      textAlign: 'center',
      padding: '60px 20px',
      color: '#666'
    }}>
      <div style={{ fontSize: '48px', marginBottom: '16px' }}>📚</div>
      <h3 style={{ marginBottom: '8px', color: '#333' }}>尚未加入任何活動</h3>
      <p style={{ marginBottom: '24px' }}>
        您還沒有加入任何活動小組，請等待老師分配或使用加入碼加入小組。
      </p>
    </div>
  );

  const renderActivities = () => {
    const displayActivities = activities;
    
    if (displayActivities.length === 0) {
      return renderEmptyState();
    }

    return (
      <div className="activity-card-list grid-responsive">
        {displayActivities.map((act, idx) => (
          <div 
            className="activity-card" 
            key={act.id} 
            style={{ 
              position: 'relative', 
              background:'#fff', 
              boxShadow:'0 2px 8px rgba(44,44,80,0.08)', 
              borderRadius: '12px', 
              border:'1.5px solid #e0e0e0',
              cursor: 'pointer'
            }}
            onClick={() => {
              // 學生點擊活動卡片，可以導向相關的學生功能
              console.log('點擊活動:', act.id);
            }}
          >
            <div className="activity-name">{act.title}</div>
            <div className="activity-date">建立時間: {formatDate(act.createdAt)}</div>
            {act.groupInfo && (
              <div className="activity-group">組別: {act.groupInfo.groupName}</div>
            )}
            {act.content && (
              <div style={{ 
                fontSize: '14px', 
                color: '#666', 
                marginTop: '8px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical'
              }}>
                {act.content}
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };

  if (loading) {
    return (
      <div className="teacher-layout">
        <div className="main-content-v2">
          <Navbar 
            menuGroups={menuGroups} 
            currentRole={currentRole}
            onRoleChange={handleRoleChange}
          />
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '400px'
          }}>
            <CircularProgress />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="teacher-layout">
      <div className="main-content-v2">
        <Navbar 
          menuGroups={menuGroups} 
          currentRole={currentRole}
          onRoleChange={handleRoleChange}
        />
        
        {error && (
          <Alert severity="error" style={{ marginBottom: '20px' }}>
            {error}
          </Alert>
        )}

        <div className="class-header-row">
          <div style={{display:'flex',alignItems:'center',gap:'10px',marginBottom:'24px'}}>
            <button
              style={{
                border: 'none',
                background: '#f1f5f9',
                borderRadius: '8px',
                padding: '4px 10px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                transition: 'background 0.18s',
              }}
              onClick={() => navigate(-1)}
              title="返回"
            >
              <ChevronLeftIcon style={{ fontSize: '1.7rem', color: '#2B687F' }} />
            </button>
            <h1 className="main-title" style={{margin:0}}>
              {userRole === 'host' ? '班級活動管理' : '我的活動'}
            </h1>
          </div>
        </div>

        {renderActivities()}
      </div>
    </div>
  );
};

export default ClassActivities; 